//export const APPLICATION_URL = "http://localhost:4000"

export const APPLICATION_URL = "https://talenttrackerhr.in"



//http://159.65.148.245
